export default __webpack_public_path__ + "static/media/72.3c7a563a.png";